<template>
    <div class="body-panel dataContent">
        <template v-if="user != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <router-link :to="'/projects/' + $route.params.projectId + '/users'">Пользователи</router-link>
                        </p>
                        <p class="caption-help margin-right-10" v-if="user.new">Новый пользователь</p>
                        <p class="caption-help margin-right-10"> {{ formatUserName(user) }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" v-if="user.new != true" @click.stop="$refs.ppChangePassword.show()">Изменить пароль</button>
                        <button type="button" class="btn btn-primary" @click="saveEntity()" v-if="roles.length > 0">Сохранить</button>
                        <button type="button" class="btn" @click="cancel()">Отмена</button>
                        <button type="button" class="btn btn-delete" @click="deleteEntity()" v-if="!user.new">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <form action="#" @submit.prevent="saveEntity" novalidate="novalidate" autocomplete="off">
                    <div class="block-in-page">
                        <div class="form-field" style="" v-if="loaded">
                            <p v-if="!user.UserDynamicRoles.length" class="error">
                                Необходимо выбрать минимум один проект
                            </p>
                            <div class="margin-bottom-20" v-for="(userRole, i) of user.UserDynamicRoles">
                                <div class="form-field-group">
                                    <div class="form-field" style="width:12.5%;">
                                        <label class="input-text-lbl">
                                            Проект
                                        </label>
                                        <label v-if="userRole.ReadOnly">
                                            {{ userRole.ProjectName }}
                                        </label>
                                        <drop-down v-else :name="'ProjectId' + i"
                                                   :items="getProjectListForRole(userRole)"
                                                   :dataField="'ProjectId'"
                                                   :textField="'ProjectName'"
                                                   data-vv-as="Проект"
                                                   v-model="userRole.ProjectId"
                                                   v-validate="{required: true}"
                                                   :class="[{'input-error': errors.has('ProjectId' + i)}]"></drop-down>
                                    </div>
                                    <div class="form-field" style="width:12.5%;">
                                        <label class="input-text-lbl">
                                            Уровень пользователя
                                        </label>
                                        <label v-if="info.User.MainRole !== 'administrators'">
                                            {{ userRole.LevelName }}
                                        </label>
                                        <drop-down v-else :name="'LevelId' + i"
                                                   :items="levelInProject"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   :withSelectItem="'true'"
                                                   v-model="userRole.LevelInProject"
                                                   data-vv-as="Уровень пользователя"
                                                   :class="[{'input-error': errors.has('LevelId' + i)}]"></drop-down>
                                    </div>
                                    <div class="form-field" style="width:12.5%;">
                                        <label class="input-text-lbl">
                                            Роль
                                        </label>
                                        <label v-if="userRole.ReadOnly">
                                            {{ userRole.RoleName }}
                                        </label>
                                        <drop-down v-else :name="'RoleId' + i"
                                                   :items="getProjectRoles(userRole)"
                                                   :dataField="'Id'"
                                                   :textField="'Name'"
                                                   :withSelectItem="'true'"
                                                   v-model="userRole.RoleId"
                                                   data-vv-as="Роль"
                                                   v-validate="{required: true}"
                                                   :class="[{'input-error': errors.has('RoleId' + i)}]"></drop-down>
                                    </div>
                                    <div class="form-field" style="width:12.5%;">
                                        <label class="input-text-lbl">
                                            Внешний ID
                                        </label>
                                        <label v-if="userRole.ReadOnly">
                                            {{ userRole.ExternalId }}
                                        </label>
                                        <input v-else :name="'ExternalId' + i" v-model="userRole.ExternalId" class="input-text" type="text" autocomplete="off" />
                                    </div>
                                    <div class="form-field" style="width:130px;min-width:130px">
                                        <label class="input-text-lbl">
                                            Дата добавления
                                        </label>
                                        <input-date :name="'AddedDateFormatted' + i"
                                                    v-model="userRole.AddedDateFormatted"
                                                    v-validate="{ rules: { required: false } }"
                                                    @input="onChangeDate(userRole, 'AddedDateFormatted', 'AddedDate')"
                                                    :class="['input-text', {'input-error': errors.has('AddedDateFormatted' + i)}]"></input-date>
                                    </div>
                                    <div class="form-field flex" style="width:100px; align-items:flex-end">
                                        <button type="button" class="btn btn-default btn-img" @click.stop="onDeleteRole(i)" v-if="!userRole.ReadOnly">
                                            <img src="../../../img/icon-del.png" alt="" />
                                        </button>
                                    </div>
                                </div>
                                <div class="margin-top-10">
                                    <div class="form-field-group">
                                        <div class="form-field shrink-group" style="width:200px;min-width:200px;margin-bottom:0;padding-top:6px;margin-right:5px">
                                            <input :id="'Disabled'+i" :name="'Disabled'+i" value="true" type="checkbox" v-model="userRole.DisabledDateTime != null" class="input-checkbox" @change="onDisabledChange($event, userRole)" autocomplete="off"/>
                                            <label :for="'Disabled'+i" class="input-checkbox-lbl">
                                                Отключить аккаунт
                                                <template v-if="userRole.DisabledDateTime">
                                                    с
                                                </template>
                                            </label>
                                        </div>
                                        <div class="form-field shrink-group margin-bottom-0" v-if="userRole.DisabledDateTime">
                                            <div class="flex">
                                                <div class="input-date-lbl" style="width:120px;min-width:120px">
                                                    <input-date name="'DisabledDateFormatted' + i"
                                                                v-model="userRole.DisabledDateFormatted"
                                                                v-validate="{ rules: { required: requiredWhen('IsDisabled', userRole)} }"
                                                                @input="onChangeDisabledDate(userRole)"
                                                                :class="['input-text', {'input-error': errors.has('DisabledDateFormatted' + i)}]"></input-date>
                                                </div>
                                                <div class="margin-left-5" style="width:60px;min-width:60px">
                                                    <input-time :name="'DisabledTimeFormatted' + i"
                                                                v-model="userRole.DisabledTimeFormatted"
                                                                @input="onChangeDisabledDate(userRole)"
                                                                :class="['input-text', {'input-error': errors.has('DisabledTimeFormatted' + i)}]"></input-time>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-group margin-top-5">
                                        <div class="form-field shrink-group" style="width:200px;min-width:200px;margin-bottom:0;padding-top:6px;margin-right:5px">
                                            <input :id="'Blocked'+i" :name="'Blocked'+i" value="true" type="checkbox"
                                                   v-model="userRole.BlockedDateTime != null" class="input-checkbox"
                                                   @change="onBlockedChange($event, userRole)" autocomplete="off"/>
                                            <label :for="'Blocked'+i" class="input-checkbox-lbl">
                                                Заблокировать вход
                                                <template v-if="userRole.BlockedDateTime">
                                                    с
                                                </template>
                                            </label>
                                        </div>
                                        <div class="form-field shrink-group margin-bottom-0" v-if="userRole.BlockedDateTime">
                                            <div class="flex">
                                                <div class="input-date-lbl" style="width:120px;min-width:120px">
                                                    <input-date :name="'BlockedDateFormatted'+i"
                                                                v-model="userRole.BlockedDateFormatted"
                                                                v-validate="{ rules: { required: requiredWhen('IsBlocked', userRole)} }"
                                                                @input="onChangeBlockedDate(userRole)"
                                                                :class="['input-text', {'input-error': errors.has('BlockedDateFormatted'+i)}]"></input-date>
                                                </div>
                                                <div class="margin-left-5" style="width:60px;min-width:60px">
                                                    <input-time :name="'BlockedTimeFormatted'+i"
                                                                v-model="userRole.BlockedTimeFormatted"
                                                                @input="onChangeBlockedDate(userRole)"
                                                                :class="['input-text', {'input-error': errors.has('BlockedTimeFormatted'+i)}]"></input-time>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary btn-img" @click="onAddRole" title="Добавить проект"
                                    v-if="user.UserDynamicRoles && user.UserDynamicRoles.length < AvailableForViewProjects.length">
                                <img src="../../../img/icon-plus-2.png">
                            </button>
                        </div>

                    </div>
                    <div class="block-in-page">

                       <div class="form-field" v-if="!user.new">
                            <label class="input-text-lbl">
                                User Id
                            </label>
                            <input name="Name"
                                   @input="userNameError = null"
                                   v-model="user.Id"
                                   class="input-text"
                                   type="text"
                                   disabled="disabled"
                                   autocomplete="off">
                       </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Email
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="Email" type="text" placeholder="Email"
                                   v-validate="'required|email'"
                                   v-model="user.Email"
                                   @input="userNameError = null"
                                   :class="['input-text', {'input-error': errors.has('Email')}]"
                                   autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('Email') }}{{userNameError}}</span>
                        </div>

                        <div class="form-field" v-if="user.new">
                            <label class="input-text-lbl">
                                Новый пароль
                            </label>
                            <input name="Password" class="input-text" type="password" autocomplete="off"
                                   :class="['input-text', {'input-error': errors.has('Password')}]"
                                   @input="onNewPasswordChange"
                                   v-validate="{ required: true }"
                                   v-model="user.Password"
                                   data-vv-as="Новый пароль">
                            <span class="field-validation-valid">{{ errors.first('Password') }}{{passwordError}}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Имя
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="FirstName"
                                   data-vv-as="Имя"
                                   v-validate="'required'"
                                   v-model="user.FirstName"
                                   :class="['input-text', {'input-error': errors.has('FirstName')}]"
                                   type="text"
                                   autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('FirstName') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Фамилия
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <input name="LastName"
                                   data-vv-as="Фамилия"
                                   v-validate="'required'"
                                   v-model="user.LastName"
                                   :class="['input-text', {'input-error': errors.has('LastName')}]"
                                   type="text"
                                   autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('LastName') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Отчество
                                <span class="required" aria-required="true"></span>
                            </label>
                            <input name="MiddleName" v-model="user.MiddleName" class="input-text" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('MiddleName') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Телефон
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <the-mask v-model="user.PhoneNumber"
                                      data-vv-as="Телефон"
                                      :mask="['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###']"
                                      name="PhoneNumber"
                                      v-validate="{ required: true, regex: /^\d{11,}$/ }" :class="['input-text', {'input-error': errors.has('PhoneNumber')}]" />
                            <span class="field-validation-valid">{{ errors.first('PhoneNumber') }}</span>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Дата рождения
                            </label>
                            <div class="input-date-lbl">
                                <input-date name="BirthDateFormatted"
                                            v-model="user.BirthDateFormatted"
                                            @input="onChangeDate(user, 'BirthDateFormatted', 'BirthDate')"
                                            :class="['input-text', {'input-error': errors.has('BirthDateFormatted')}]"></input-date>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Пол
                                <span class="required" aria-required="true">*</span>
                            </label>
                            <drop-down v-if="genders.length > 0"
                                       :name="'Gender'"
                                       :items="genders"
                                       :dataField="'Value'"
                                       :textField="'Name'"
                                       :withSelectItem="'true'"
                                       v-model="user.Gender"
                                       data-vv-as="Пол"
                                       v-validate="{required: true}"
                                       :class="[{'input-error': errors.has('Gender')}]"></drop-down>
                            <span class="field-validation-valid">{{ errors.first('Gender') }}</span>
                        </div>

                        <template v-if="!user.new">
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Торговая точка
                                </label>
                                <input name="TradePointName" class="input-text" type="text" v-model="user.TradePointName" autocomplete="off" />
                            </div>

                            <div class="form-field" v-for="(item, i) of user.RegFields">
                                <label class="input-text-lbl">
                                    {{item.FieldName}}
                                </label>
                                <input :name="'fieldName' + i" type="text" :placeholder="item.FieldName"
                                       v-if="item.FieldType === 'text'"
                                       v-model="item.Value"
                                       :class="['input-text', {'input-error': errors.has('fieldName' + i)}]">
                                <drop-down v-else-if="item.FieldType === 'select'"
                                           :items="item.optionsItems" :dataField="'Value'" :textField="'Name'" v-model="item.Value"></drop-down>
                            </div>

                            <div class="form-field">
                                <label class="input-text-lbl">Создание аккаунта: {{formatDate(user.RegisterDate, 'DD.MM.YYYY HH:mm')}}</label>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">Активация аккаунта: {{formatDate(user.UserActivationDateTime, 'DD.MM.YYYY HH:mm')}}</label>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">Проверка аккаунта: {{formatDate(user.RegisterApprovementDateTime, 'DD.MM.YYYY HH:mm')}}</label>
                            </div>

                        </template>

                        <div class="form-field" v-if="user.RegisteredManually && user.RegisterStatus === 1">
                            <div class="btns flex">
                                <button type="button" class="btn btn-primary" @click="activateAccount()">Активировать аккаунт</button>
                                <button type="button" class="btn btn-delete" v-if="user.RegisterStatus !== 3" @click.stop="showRefuseAccountModal()">Отказать в регистрации</button>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page">
                        <div class="form-field" v-if="user.PassportVerificationState === VerificationStates.NeedToCheck">
                            <p class="error">Требуется подтвердить документы пользователя</p>
                            <div class="flex btns">
                                <button type="button" class="btn btn-primary" @click.stop="approveDocs()">Документы проверены</button>
                                <button type="button" class="btn btn-delete" @click.stop="showReturnDocsModal()">Отклонить документы</button>
                                <button type="button" class="btn btn-primary" @click.stop="CheckInn()">Проверить ИНН</button>
                            </div>
                            <div class="task-photo" v-for="(item, i) of innVerificationErrors">
                                <p class="error">{{item}}</p>
                            </div>
                            <p class="approve" v-if="checkedInn">ИНН совпадает</p>
                        </div>
                        <div class="form-field" v-else-if="user.PassportVerificationState === VerificationStates.Verified">
                            <div class="flex btns">
                                <button type="button" class="btn btn-delete" @click.stop="showReturnDocsModal()">Отклонить документы</button>
                            </div>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Вид документа
                            </label>
                            <drop-down :items="documentTypes"
                                       :dataField="'Id'"
                                       :textField="'Name'"
                                       v-model="user.DocumentType"></drop-down>
                        </div>

                        <div class="form-field" v-if="user.DocumentType === 2">
                            <label class="input-text-lbl">
                                Страна выдачи
                            </label>
                            <input name="PassportIssuedCountry"
                                   v-model="user.PassportIssuedCountry"
                                   data-vv-scope="docs"
                                   data-vv-as="Страна выдачи"
                                   :class="['input-text', {'input-error': errors.has('PassportIssuedCountry')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('PassportIssuedCountry') }}</span>
                        </div>

                        <div class="form-field margin-top-15">
                            <label class="input-text-lbl">
                                Серия паспорта
                            </label>
                            <input v-if="user.DocumentType === 2" class="input-text"
                                   name="PassportSeries2"
                                   v-model="user.PassportSeries"
                                   type="text" autocomplete="off">
                            <the-mask v-else v-model="user.PassportSeries"
                                      :mask="PassportSeriesMask"
                                      name="PassportSeries"
                                      data-vv-as="Серия паспорта"
                                      @input="onChangePassport"
                                      v-validate="{passportSeries: PassportSeriesMaxLength}"
                                      :class="['input-text', {'input-error': errors.has('PassportSeries')}]" />
                            <span class="field-validation-valid">{{ errors.first('PassportSeries') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Номер паспорта
                            </label>
                            <input name="PassportNumber"
                                   v-model="user.PassportNumber"
                                   data-vv-as="Номер паспорта"
                                   @input="onChangePassport"
                                   v-validate="{passportNumber: PassportNumberMaxLength}"
                                   :class="['input-text', {'input-error': errors.has('PassportNumber')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('PassportNumber') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Кем выдан
                            </label>
                            <input name="PassportIssuedBy"
                                   v-model="user.PassportIssuedBy"
                                   data-vv-as="Кем выдан"
                                   :class="['input-text', {'input-error': errors.has('PassportIssuedBy')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('PassportIssuedBy') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Номер подразделения
                            </label>
                            <the-mask :mask="'###-###'" name="PassportIssuedCode"
                                      v-model="user.PassportIssuedCode"
                                      data-vv-as="Номер подразделения"
                                      :class="['input-text', {'input-error': errors.has('PassportIssuedCode')}]" />
                            <span class="field-validation-valid">{{ errors.first('PassportIssuedCode') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Дата выдачи
                            </label>
                            <div class="input-date-lbl">
                                <input-date name="PassportIssuedDateFormatted"
                                            v-model="user.PassportIssuedDateFormatted"
                                            data-vv-as="Дата выдачи"
                                            @input="onChangeDate(user, 'PassportIssuedDateFormatted', 'PassportIssuedDate')"
                                            :class="['input-text', {'input-error': errors.has('PassportIssuedDateFormatted')}]"></input-date>
                            </div>
                            <span class="field-validation-valid">{{ errors.first('PassportIssuedDateFormatted') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                Адрес регистрации
                            </label>
                            <input name="PassportRegistrationAddress"
                                   v-model="user.PassportRegistrationAddress"
                                   data-vv-as="Адрес регистрации"
                                   :class="['input-text', {'input-error': errors.has('PassportRegistrationAddress')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('PassportRegistrationAddress') }}</span>
                        </div>

                        <div class="form-field">
                            <label class="input-text-lbl">
                                {{user.DocumentType === 2 ? 'ИНН/ИНП/ИИН' : 'ИНН'}}
                            </label>
                            <input name="INN"
                                   v-model="user.Inn"
                                   @blur=""
                                   data-vv-as="ИНН"
                                   v-validate="{innfl: user.DocumentType !== 2, regex: /^[a-zа-яё0-9]*$/iu }"
                                   :class="['input-text', {'input-error': errors.has('INN')}]" type="text" autocomplete="off">
                            <span class="field-validation-valid">{{ errors.first('INN') }}</span>
                        </div>

                        <div class="thumbnail-img-block">
                            <div class="thumbnail-img" v-for="(img, i) of user.Images">
                                <a :href="img.FileData" class="lightzoom" rel="group" v-if="img.FileData">
                                    <img :src="img.FileData" />
                                </a>
                                <a :href="img.FileName" class="lightzoom" rel="group" v-else-if="img.FileName">
                                    <img :src="img.FileName" />
                                </a>
                                <div class="thumbnail-img-delete" @click="removeDocument(i)"></div>
                                <div class="thumbnail-img-rotateleft" @click="rotateImage('left', img)" v-if="!img.FileData"></div>
                                <div class="thumbnail-img-rotateright" @click="rotateImage('right', img)" v-if="!img.FileData"></div>
                            </div>
                        </div>
                        <div class="file-upload-zone" style="height: 100px;">
                            <drop-zone id="dropZoneFiles" class="drop-area file-upload-zone" @files-dropped="onAttachFiles" style="height:100%;" 
                                       :value="user.Images.length" name="dropZoneFiles" data-vv-as="Фотография">
                                <input type="file" id="dropFiles2" ref="dropFiles2" name="dropFiles2"
                                       class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" multiple />
                                <label id="dropFiles2BtnLbl" for="dropFiles2" :class="['file-upload-zone-lbl', {'input-error': errors.has('dropZoneFiles')}]">Прикрепите фотографию второго и третьего разворота паспорта и ИНН</label>
                            </drop-zone>
                        </div>
                    </div>

                    <div class="block-in-page">
                        <div class="form-field" v-if="user.PaymentVerificationState === VerificationStates.NeedToCheck">
                            <p class="error">Требуется подтвердить банковские реквизиты пользователя</p>
                            <div class="flex btns">
                                <button type="button" class="btn btn-primary" @click.stop="approvePaymentSettings()">Банковские реквизиты проверены</button>
                                <button type="button" class="btn btn-delete" @click.stop="$refs.ppReturnPayment.show()">Отклонить</button>
                            </div>
                        </div>
                        <div class="form-field" v-else-if="user.PaymentVerificationState === VerificationStates.Verified">
                            <p class="approve">
                                Реквизиты подтверждены <span>{{user.SettingsDateApprovement | date-long}}</span>
                            </p>
                            <div class="flex btns">
                                <button type="button" class="btn btn-delete" @click.stop="$refs.ppReturnPayment.show()">Отклонить</button>
                            </div>
                        </div>
                        <div class="form-field" v-else-if="user.PaymentVerificationState === VerificationStates.Cancelled">
                            <p class="error">
                                Данные банковской карты были отклонены по следующей причине: {{ user.PaymentComment }}
                            </p>
                        </div>

                        <div class="form-field margin-top15" v-if="user.SettingsDateAdd">
                            <label class="input-text-lbl">
                                Документы добавлены: {{user.SettingsDateAdd | date-long}}
                            </label>
                        </div>
                        <div :class="['form-field', {'margin-top-15': !user.SettingsDateAdd}]">
                            <label class="input-text-lbl">
                                БИК банка
                            </label>
                            <input name="PassportIssuedCountry" disabled="disabled"
                                   v-model="user.BankBik"
                                   v-validate="{ rules: { required: false } }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('BankBik')}]" type="text" autocomplete="off">
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Корреспондентский счёт
                            </label>
                            <input name="PassportIssuedCountry" disabled="disabled"
                                   v-model="user.BankCorrAccount"
                                   v-validate="{ rules: { required: false } }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('BankCorrAccount')}]" type="text" autocomplete="off">
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Наименование банка
                            </label>
                            <input name="PassportIssuedCountry" disabled="disabled"
                                   v-model="user.BankName"
                                   v-validate="{ rules: { required: false } }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('BankName')}]" type="text" autocomplete="off">
                        </div>
                        <div class="form-field">
                            <label class="input-text-lbl">
                                Расчётный счёт
                            </label>
                            <input name="PassportIssuedCountry" disabled="disabled"
                                   v-model="user.BankPaymentAccount"
                                   v-validate="{ rules: { required: false } }"
                                   data-vv-scope="docs"
                                   :class="['input-text', {'input-error': errors.has('BankPaymentAccount')}]" type="text" autocomplete="off">
                        </div>
                    </div>
                </form>

                <div v-if="roles.length === 0">
                    Добавьте роли в проект!<br />
                    <router-link :to="'/projects/' + $route.params.projectId + '/roles'">Управление ролями</router-link>
                </div>
            </div>
        </template>

        <popup-window ref="ppReturn" :title="'Вернуть документы'" v-if="user != null">
            <div class="form-field">
                <label class="input-text-lbl">Причина возврата</label>
                <textarea name="PassportVerificationComment" rows="10" class="input-memo"
                          v-model="user.PassportVerificationComment"></textarea>
            </div>
            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex" data-toggle="buttons">
                        <button type="button" class="btn btn-primary" @click="returnDocs()">Сохранить</button>
                        <button type="button" class="btn" @click="closeModal('ppReturn')">Отмена</button>
                    </div>
                </div>
            </template>
        </popup-window>

        <popup-window ref="ppReturnPayment" :title="'Вернуть реквизиты'" v-if="user != null">
            <div class="form-field">
                <label class="input-text-lbl">Причина возврата</label>
                <textarea name="PaymentComment" rows="10"
                          v-validate ="{ rules: { required: true} }"
                          :class="['input-memo', {'input-error': errors.has('PaymentComment', 'returnPayment')}]"
                          data-vv-scope="returnPayment"
                          v-model="user.PaymentComment"></textarea>
            </div>
            <template v-slot:footer>
                <div class="popup-footer">
                    <div class="btns flex" data-toggle="buttons">
                        <button type="button" class="btn btn-primary" @click="returnPaymentSettings()">Сохранить</button>
                        <button type="button" class="btn" @click="closeModal('ppReturnPayment')">Отмена</button>
                    </div>
                </div>
            </template>
        </popup-window>

        <popup-window ref="ppRefuse" :title="'Отказать в регистрации'" v-if="user != null">
            <div class="form-field">
                <label class="input-text-lbl">Причина отказа</label>
                <textarea name="RegistrationComment" rows="10"
                          :class="['input-memo', { 'input-error': errors.has('RegistrationComment', 'refuse') }]"
                          v-validate="{required: true}"
                          data-vv-scope="refuse"
                          v-model="user.RegisterComment"></textarea>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="refuseAccount()">Отказать</button>
                <button type="button" class="btn" @click="closeModal('ppRefuse')">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppChangePassword" :title="'Смена пароля'" v-if="user != null">
            <div class="form-field">
                <label class="input-text-lbl">
                    Новый пароль
                </label>
                <input name="UserPassword" class="input-text" type="password" autocomplete="off"
                       @input="onNewPasswordChange"
                       v-validate="{ required: true }"
                       v-model="user.Password"
                       data-vv-scope="changepassword">
                <span class="field-validation-valid">{{ errors.first('UserPassword', 'changepassword') }}{{passwordError}}</span>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="onChangePassword()">Изменить</button>
                <button type="button" class="btn" @click="closeModal('ppChangePassword')">Отмена</button>
            </div>
        </popup-window>

        <vue-headful title="Управление пользователями" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import fancybox from '../../assets/FancyBox/jquery.fancybox.pack.js'
    import fancyboxcss from '../../assets/FancyBox/jquery.fancybox.css'
    import jqueryui from '../../assets/JqueryUI/jquery-ui.min'
    import _ from 'lodash'
    import {UserLevelCode, VerificationStates} from '../../enums'

    let backendApi = new BackendApi();
    export default {
        name: "user-edit",

        props:['info'],

        data() {
            return {
                user: null,
                roles: [],
                passwordError: null,
                userNameError: null,
                documentTypes: [
                    { Id: 1, Name: 'Паспорт гражданина Российской Федерации' },
                    { Id: 2, Name: 'Паспорт иностранного гражданина' },
                    { Id: 3, Name: 'Вид на жительство' }
                ],
                genders:[
                    {Value: false, Name: 'Женский'},
                    {Value: true, Name: 'Мужской'}
                ],
                currentUserProjects: null,
                AvailableForViewProjects: [],
                loaded: false,
                VerificationStates,
                levelInProject: [
                    { Id: 1, Name: 'Бронза' },
                    { Id: 2, Name: 'Серебро' },
                    { Id: 3, Name: 'Золото' },
                    { Id: 4, Name: 'Платина' },
                    { Id: 5, Name: 'Грейд B' },
                    { Id: 6, Name: 'Грейд A' },
                    { Id: 7, Name: 'Грейд S' }
                ],
                checkedInn: false,
                innVerificationErrors: []
            }
        },

        computed: {
            PassportSeriesMask() {
                return this.user.DocumentType === 1 ? '## ##' : '##';
            },

            PassportSeriesMaxLength() {
                return this.user.DocumentType === 1 ? 4 : 2;
            },

            PassportNumberMaxLength() {
                if(this.user.DocumentType !== 2) {
                    return this.user.DocumentType === 3 ? 7 : 6;
                } else {
                    return false;
                }
            }
        },

        methods: {
            onAddRole(){
                this.user.UserDynamicRoles.push({
                    ProjectId: null,
                    RoleId: null,
                    ExternalId: null,
                    AddedDateFormatted: this.formatDate(new Date(), 'DD.MM.YYYY')
                });
            },

            onDeleteRole(i){
                this.user.UserDynamicRoles.splice(i, 1);
            },

            getProjectRoles(userRole) {
                let project = _.find(this.roles, {ProjectId: userRole.ProjectId});
                return project ? project.Roles : [];
            },

            getProjectListForRole(userRole){
                return  _.filter(this.roles, (x) => {
                    return (x.ProjectId === userRole.ProjectId || !_.some(this.user.UserDynamicRoles, {ProjectId: x.ProjectId}))
                        && _.some(this.AvailableForViewProjects, (y) => y === x.ProjectId);
                });
            },

            formatUserName(user){
                  return [user.LastName, user.FirstName, user.MiddleName].filter(x => x).join(' ');
            },

            cancel() {
                this.$router.back();
            },

            showReturnDocsModal(){
                this.$refs.ppReturn.show();
            },

            returnDocs(){
                this.user.PassportVerificationState = 3;
                this.$refs.ppReturn.close();
                this.saveEntity();
            },

            approveDocs(){
                this.user.PassportVerificationState = 2;
                this.saveEntity();
            },

            approvePaymentSettings(){
                let vm = this;
                backendApi.savePaymentSettings({
                    userName: vm.$route.params.userName,
                    stateId: VerificationStates.Verified
                }).then(function (response) {
                    UI.unblockUI('.dataContent');
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении данных');
                    } else {
                        vm.user.PaymentVerificationState = VerificationStates.Verified;
                        vm.user.SettingsDateApprovement = response.data;

                        UI.toastr.success('Успешно сохранено');
                    }
                });
            },

            returnPaymentSettings(){
                let vm = this;
                this.$validator.validateAll('returnPayment').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    } else {
                        backendApi.savePaymentSettings({
                            userName: vm.$route.params.userName,
                            comment: vm.user.PaymentComment,
                            stateId: VerificationStates.Cancelled
                        }).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении данных');
                            } else {
                                vm.user.PaymentVerificationState = VerificationStates.Cancelled;

                                UI.toastr.success('Успешно сохранено');
                                vm.closeModal('ppReturnPayment');
                            }
                        });

                    }
                });
            },

            closeModal(popupName){
               this.$refs[popupName].close();
            },

            activateAccount(){
                let vm = this;

                this.$validator.validate().then(result => {
                    if (result) {
                        vm.user.RegisterStatus = 2;
                        vm.saveEntity();
                    }
                });
            },

            showRefuseAccountModal(){
                this.$nextTick(() => {
                    this.$refs.ppRefuse.show();
                });
            },

            refuseAccount(){
                let vm = this;
                vm.$validator.validateAll('refuse').then(result => {
                    if (result) {
                        let dto = {
                            ProjectId: vm.$route.params.projectId,
                            UserName: vm.user.UserName,
                            RegisterComment: vm.user.RegisterComment

                        };
                        vm.$refs.ppRefuse.close();
                        backendApi.userRefuse(dto).then(function (response) {
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении пользователя');
                            } else {
                                UI.toastr.success('В регистрации отказано');
                                vm.$router.push('/projects/' + vm.$route.params.projectId + '/users');
                            }
                        });
                    }
                });
            },

            loadEntity() {
                let vm = this;
                let userName = vm.$route.params.userName;
                let projectId = vm.$route.params.projectId;

                return backendApi.userLoad(userName, projectId).then(function (response) {
                    //console.info('project.edit -> load, response:', response.data);
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке пользователя');
                    }
                    else {
                        vm.roles = response.data.Roles;

                        if (userName === '0') {
                            vm.user = {
                                new: true,
                                Id: null,
                                UserDynamicRoles: [],
                                Images: [],
                                RegFields: []
                            };
                        }
                        else {
                            if(response.data.User == null)
                            {
                                vm.$router.push('/projects/' + projectId + '/users/');
                            }
                            if(response.data.User.RoleId === 0)
                            {
                                response.data.User.RoleId = '';
                            }
                            vm.user = response.data.User;
                            vm.user.RegFields = response.data.RegFields;
                            vm.user.new = false;
                            if(vm.user.BirthDate)
                            {
                                vm.user.BirthDateFormatted = vm.formatDate(vm.user.BirthDate);
                            }
                            if(vm.user.PassportIssuedDate)
                            {
                                vm.user.PassportIssuedDateFormatted = vm.formatDate(vm.user.PassportIssuedDate);
                            }

                            for(let userRole of vm.user.UserDynamicRoles){
                                if(userRole.DisabledDateTime)
                                {
                                    userRole.DisabledDateFormatted = vm.formatDate(userRole.DisabledDateTime, 'DD.MM.YYYY');
                                    userRole.DisabledTimeFormatted = vm.formatDate(userRole.DisabledDateTime, 'HH:mm');
                                }
                                if(userRole.BlockedDateTime)
                                {
                                    userRole.BlockedDateFormatted = vm.formatDate(userRole.BlockedDateTime, 'DD.MM.YYYY');
                                    userRole.BlockedTimeFormatted = vm.formatDate(userRole.BlockedDateTime, 'HH:mm');
                                }
                                if(userRole.AddedDateTime) {
                                    userRole.AddedDateFormatted = vm.formatDate(userRole.AddedDateTime, 'DD.MM.YYYY');
                                }
                                switch (userRole.LevelInProject) {
                                    case UserLevelCode.Bronze:
                                        userRole.LevelName = 'Бронза';
                                        break;
                                    case UserLevelCode.Silver:
                                        userRole.LevelName = 'Серебро';
                                        break;
                                    case UserLevelCode.Gold:
                                        userRole.LevelName = 'Золото';
                                        break;
                                    case UserLevelCode.Platina:
                                        userRole.LevelName = 'Платина';
                                        break;
                                    case UserLevelCode.GradeB:
                                        userRole.LevelName = 'Грейд B';
                                        break;
                                    case UserLevelCode.GradeA:
                                        userRole.LevelName = 'Грейд A';
                                        break;
                                    case UserLevelCode.GradeS:
                                        userRole.LevelName = 'Грейд S';
                                        break;
                                        }
                            }

                            for(let field of vm.user.RegFields) {
                                if(field.FieldType === 'select') {
                                    let options = JSON.parse(field.Options);
                                    field.optionsItems = options.map(y => ({Value: y, Name: y}))
                                    if(options.length > 0 && options[0] !== '') {
                                        field.optionsItems.unshift({Value: 'Выбор', Name: 'Выбор'});
                                    };
                                }
                            }
                        }
                    }
                })
            },

            onChangePassword(){
                let vm = this;
                this.$validator.validateAll('changepassword').then(result => {
                    if (!result || vm.passwordError) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        UI.blockUI('.dataContent', 'Сохранение...');
                        // let saveObj = Object.assign({}, {
                        //     UserName: ,
                        //     Password:
                        // });
                        // console.info('save pass', saveObj);
                        backendApi.userSavePassword(vm.user.UserName, vm.user.Password).then(function (response) {
                            UI.unblockUI('.dataContent');

                            if (response.hasError) {
                                if (response.status === 9) {
                                    vm.passwordError = 'Некорректное значение';
                                }
                                UI.toastr.error('Ошибка при сохранении пароля');
                            } else {
                                UI.toastr.success('Пароль успешно обновлён');
                                vm.user.Password=null;
                                vm.closeModal('ppRefuse');
                            }
                        });
                    }
                });
            },

            saveEntity() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result || !vm.user.UserDynamicRoles.length) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        UI.blockUI('.dataContent', 'Сохранение...');

                        let saveObj = Object.assign({}, vm.user, {
                            ProjectId: vm.$route.params.projectId
                        });
                        for(let field of saveObj.RegFields) {
                            if(field.FieldType === 'select' && field.Value === 'Выбор') {
                                field.Value = '';
                            }
                        }
                        backendApi.userSave(saveObj).then(function (response) {
                            //console.info('details -> userSave, response:', response);
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                if (response.status === 9) {
                                    vm.passwordError = 'Некорректное значение';
                                }
                                else if(response.status === 10){
                                    vm.userNameError = 'Email уже используется';
                                }
                                UI.toastr.error('Ошибка при сохранении пользователя');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.$router.push('/projects/' + vm.$route.params.projectId + '/users');
                            }
                        });
                    }
                });
            },

            loadUserProjects(){
                let vm = this;
                return backendApi.projectList(0, 100).then(function (response) {
                    vm.currentUserProjects = response.data;
                });
            },

            onNewPasswordChange() {
                this.passwordError = null;

                if (!this.user.Password || !this.user.Password.trim()) {
                    //this.password.Error = null;
                } else {
                    let newpass = this.user.Password;

                    if (newpass.length < 6) {
                        this.passwordError = 'Введите минимум 6 символов';
                    }
                    else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                        this.passwordError = 'Обязательно наличие и букв и цифр';
                    }
                    else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                        this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                    }
                }
            },

            deleteEntity() {
                let that = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.userDelete(that.user.UserName).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении пользователя');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/projects/' + that.$route.params.projectId + '/users');
                        }
                    });
                }
            },

            removeDocument(i){
                if(confirm('Удалить файл?')) {
                    this.user.Images.splice(i, 1);
                    this.$refs.dropFiles2.value = '';
                }
            },

            rotateImage(direction, img){
                let vm = this;

                vm.callApiWrapper(backendApi.rotateUserDocument(img.Id, direction))
                    .then(function (response) {
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при изменении изображения');
                        } else {
                            img.FileName = response.data;
                        }
                    });
            },

            zoomIn(){
                let $img = $.fancybox.wrap.find('img.fancybox-image');
                let scale = $img.data('scale') || 1.0;
                scale += 0.2;
                $img.css('transform','scale('+(scale)+')');
                $img.data('scale', scale);
            },

            zoomOut(){
                let $img = $.fancybox.wrap.find('img.fancybox-image');
                let scale = $img.data('scale') || 1.0;
                scale -= 0.2;
                if(scale < 0.5){
                    return false;
                }
                $img.css('transform','scale('+(scale)+')');
                $img.data('scale', scale);
            },

            onChangeDate(item, formatted, raw, format = 'DD.MM.YYYY') {
                item[raw] = moment(item[formatted], format).format();

            },

            onChangeDisabledDate(userRole) {
                userRole.DisabledDateTime = moment(userRole.DisabledDateFormatted + ' ' + userRole.DisabledTimeFormatted, 'DD.MM.YYYY HH:mm').format();
            },

            onChangeBlockedDate(userRole) {
                userRole.BlockedDateTime = moment(userRole.BlockedDateFormatted + ' ' + userRole.BlockedTimeFormatted, 'DD.MM.YYYY HH:mm').format();
            },

            onDisabledChange($event, userRole){
                const checked = $event.target.checked;
                if(!checked){
                    userRole.DisabledDateTime = null;
                    userRole.DisabledDateFormatted = null;
                    userRole.DisabledTimeFormatted = null;
                }else{
                    let dateTime = moment().format();
                    userRole.DisabledDateTime = dateTime;
                    userRole.DisabledDateFormatted = this.formatDate(dateTime, 'DD.MM.YYYY');
                    userRole.DisabledTimeFormatted = this.formatDate(dateTime, 'HH:mm');
                }
            },

            onBlockedChange($event, userRole){
                const checked = $event.target.checked;
                if(!checked){
                    userRole.BlockedDateTime = null;
                    userRole.BlockedDateFormatted = null;
                    userRole.BlockedTimeFormatted = null;
                }else {
                    let dateTime = moment().format();
                    userRole.BlockedDateTime = dateTime;
                    userRole.BlockedDateFormatted = this.formatDate(dateTime, 'DD.MM.YYYY');
                    userRole.BlockedTimeFormatted = this.formatDate(dateTime, 'HH:mm');
                }
            },

            requiredWhen(prop, userRole){
                return userRole[prop] == true;
            },

            onAttachFiles(obj) {
                let files = obj.files;
                let vm = this;
                if (files && files.length) {
                    for (let file of files) {
                        if (file.size > 50 * 1024 * 1024) {
                            UI.toastr.error('Превышен размер. Выберите другой файл');
                            $('input[name="dropFiles2"]').val('');
                        } else {
                            //this.$refs.dropFiles2.value = file.name;
                            //dropFiles2
                            //console.info('onAttachFiles', this.$refs.dropFiles2);
                            let img = { FileName: file.name, FileData: null, Delete: false };
                            let reader = new FileReader();
                            reader.onload = function (e) {
                                img.FileData = e.target.result;

                                vm.user.Images.push(img);
                            };
                            reader.readAsDataURL(file);
                        }
                    }
                }
            },

            CheckInn() {
                let vm = this;
                this.$validator.validate().then(result => {
                    if (!result || !vm.user.UserDynamicRoles.length) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        UI.blockUI('.dataContent', 'Проверка...');

                        let saveObj = Object.assign({}, vm.user, {});
                        saveObj.PassportSeries = vm.user.PassportSeries.slice(0, 2) + ' ' + vm.user.PassportSeries.slice(2);
                        backendApi.userCheckInn(saveObj).then(function (response) {
                            //console.info('details -> userSave, response:', response);
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при проверке');
                            } else {
                               //UI.toastr.success('Успешно сохранено');
                                if (!response.data.inn) {
                                    vm.checkedInn = false;
                                    vm.innVerificationErrors = response.data.errors;
                                } else if (response.data.inn === saveObj.Inn) {
                                    vm.checkedInn = true;
                                    vm.innVerificationErrors = [];
                                } else {
                                    vm.checkedInn = false;
                                    vm.innVerificationErrors = ['ИНН не совпадает'];
                                }
                            }
                        });
                    }
                });
            },

            onChangePassport() {
                this.checkedInn = false;
                this.innVerificationErrors = [];
            }
        },

        mounted() {
            let vm = this;
            UI.blockUI('.dataContent', 'Загрузка...');
            Promise.all([this.loadEntity(), this.loadUserProjects()]).then(() => {

                vm.AvailableForViewProjects =
                    _.uniq(_.concat(_.map(this.currentUserProjects, (x) => x.Id), _.map(this.user.UserDynamicRoles, (x) => x.ProjectId)));

                UI.unblockUI('.dataContent');

                $('.lightzoom').fancybox({
                    beforeShow: function() {
                        let $div = $(`<div class="btns flex">
<button type="button" class="btn btn-primary zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>
<button type="button" class="btn btn-primary zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>
</div>`);
                        $.fancybox.wrap.find('.fancybox-outer').before($div);
                        $.fancybox.wrap.find('img.fancybox-image').draggable();
                    }
                });

                $(document).on('click', '.zoom-plus', function(){
                    vm.zoomIn();

                });
                $(document).on('click', '.zoom-minus', function(){
                    vm.zoomOut();
                });

                $(window).bind('mousewheel DOMMouseScroll', function(event){
                    if($.fancybox.wrap != null){
                        if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                            vm.zoomOut();
                        }
                        else {
                            vm.zoomIn();
                        }
                    }
                });

                $(document).on('change', '[name="dropFiles2"]', function () {
                    vm.onAttachFiles({ files: this.files });
                });

                for(let role of vm.user.UserDynamicRoles){
                    if(!_.some(vm.currentUserProjects, (x) => x.Id === role.ProjectId)){
                        role.ReadOnly = true;
                    }
                }

                vm.loaded = true;
            });
        },

        destroyed(){
            $(window).unbind('mousewheel DOMMouseScroll');
        }

    }
</script>

<style>
    .fancybox-inner {overflow: hidden !important;}
    .fancybox-nav{width: 40px !important;}

    .form-field.shrink-group{
        width:auto;
    }
    .form-field.shrink-group .input-checkbox-lbl{
        margin-top: 0;
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/UserEdit.vue